import { render, staticRenderFns } from "./DginView.vue?vue&type=template&id=28f3c882&scoped=true"
import script from "./DginView.vue?vue&type=script&lang=js"
export * from "./DginView.vue?vue&type=script&lang=js"
import style0 from "./DginView.vue?vue&type=style&index=0&id=28f3c882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3c882",
  null
  
)

export default component.exports